import React from 'react';
import * as styles from './index.module.less';
import NottaLogo from '@/images/Logo-Notta-Dark.png';
import { Wrapper } from '../Header';
import LanguagesSelector from '../languages-selector';
import { SOCIAL_MEDIA_INFO } from './constant';

export const FooterLinkList = () => {
  const LinkWrapper = Wrapper(false);

  return (
    <div className={styles.footer_link__layout}>
      <div className={styles.list_header}>
        <div className={styles.list_header__left}>
          <img src={NottaLogo} alt="Notta" />
          <div className={styles.social_media__list}>
            {SOCIAL_MEDIA_INFO.map((item) => {
              return (
                <a key={item.link} href={item.link} target="_blank" rel="noreferrer">
                  <img src={item.icon.src} className={styles.social_media_logo} loading="lazy" alt={item.icon.alt} />
                </a>
              );
            })}
          </div>
        </div>
        <div className={styles.language_selector_wrapper}>
          <LanguagesSelector showTriggerLabel curLanguage="ja" />
        </div>
      </div>
      <div className={styles.link_content}>
        <div className={styles.item}>
          <div className={styles.title}>Nottaについて</div>
          <LinkWrapper to="/web" className="text-link-new footer">
            Web版
          </LinkWrapper>
          <LinkWrapper to="/mobile" className="text-link-new footer">
            アプリ
          </LinkWrapper>
          <LinkWrapper to="/chrome-extension" id="footer-extension" className="text-link-new footer">
            Chrome拡張機能
          </LinkWrapper>
          <LinkWrapper to="/pricing" className="text-link-new footer">
            料金プラン
          </LinkWrapper>
        </div>
        <div className={styles.item}>
          <div className={styles.title}>お役立ち情報</div>
          <a href="/blog" target="_self" className="text-link-new footer">
            ブログ
          </a>
          <LinkWrapper to="/company" className="text-link-new footer">
            会社概要
          </LinkWrapper>
          <LinkWrapper to="/news" className="text-link-new footer">
            新着情報
          </LinkWrapper>
          <LinkWrapper to="/recruit" className="text-link-new footer">
            採用情報
          </LinkWrapper>
          <LinkWrapper to="https://support.notta.ai/hc/ja" className="text-link-new footer">
            ヘルプセンター
          </LinkWrapper>
          <LinkWrapper to="/education-plan" className="text-link-new footer">
            学割・教職員割引
          </LinkWrapper>
          <LinkWrapper to="/media-kit" className="text-link-new footer">
            メディアキット
          </LinkWrapper>
        </div>
        <div className={styles.item}>
          <div className={styles.title}>連絡情報</div>
          <LinkWrapper to="/inquiry" className="text-link-new footer">
            お問い合わせ
          </LinkWrapper>
          <LinkWrapper to="/request" className="text-link-new footer">
            書類発行依頼
          </LinkWrapper>
          <LinkWrapper to="/about" className="text-link-new footer">
            資料請求
          </LinkWrapper>
          <LinkWrapper to="/resources/remote-work-and-dx" className="text-link-new footer">
            リサーチ資料
          </LinkWrapper>
          <LinkWrapper to="/affiliate" className="text-link-new footer">
            アフィリエイター募集
          </LinkWrapper>
          <LinkWrapper to="/guides" className="text-link-new footer">
            よくあるご質問
          </LinkWrapper>
        </div>
        <div className={styles.item}>
          <div className={styles.title}>活用シーン</div>
          <LinkWrapper to="/use-cases/writer" className="text-link-new footer">
            ライター
          </LinkWrapper>
          <LinkWrapper to="/use-cases/business" className="text-link-new footer">
            営業担当
          </LinkWrapper>
          <LinkWrapper to="/use-cases/student" className="text-link-new footer">
            学生
          </LinkWrapper>
          <LinkWrapper to="/use-cases/hearing-impaired" className="text-link-new footer">
            聴覚障がい者
          </LinkWrapper>
        </div>
        <div className={styles.item}>
          <div className={styles.title}>無料ツール</div>
          <LinkWrapper to="/tools/audio-to-text-converter" className="text-link-new footer">
            オンライン音声文字起こしコンバーター
          </LinkWrapper>
          <LinkWrapper to="/tools/online-video-converter" className="text-link-new footer">
            フリーオンライン動画変換
          </LinkWrapper>
          <LinkWrapper to="/tools/online-audio-converter" className="text-link-new footer">
            オンライン音声変換
          </LinkWrapper>
          <LinkWrapper to="/tools/online-vocal-remover" className="text-link-new footer">
            ボーカルリムーバー
          </LinkWrapper>
        </div>
      </div>
    </div>
  );
};
